var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 8.12095C3.09368 6.3278 3.1415 5.43122 3.72016 4.8826C4.29881 4.33398 5.19666 4.33398 6.99237 4.33398H9.00765C10.8034 4.33398 11.7012 4.33398 12.2799 4.8826C12.8585 5.43122 12.9063 6.3278 13.002 8.12095L13.1086 10.121C13.2141 12.0977 13.2668 13.0861 12.6752 13.71C12.0836 14.334 11.0939 14.334 9.11432 14.334H6.8857C4.90616 14.334 3.91638 14.334 3.32481 13.71C2.73324 13.0861 2.78596 12.0977 2.89138 10.121L2.99805 8.12095Z",
    stroke: "#15222F",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 3.66699C6.00003 2.56249 6.89553 1.66699 8.00003 1.66699C9.10453 1.66699 10 2.56249 10 3.66699",
    stroke: "#15222F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.81830f1f.svg";
export { ForwardRef as ReactComponent };